import HTTP from "../../http";

const USERS_ENDPOINT = "/users";
const CREATE_GUEST_USER_ENDPOINT = "/createGuestUser";

export async function createGuestUser(email, verify_route, cart_id) {
  return await HTTP.post(
    USERS_ENDPOINT + CREATE_GUEST_USER_ENDPOINT,
    { email, verify_route, cart_id },
    {
      headers: { "Content-Type": "application/json" }
    }
  );
}
